
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { MasterDegreeTypeResponse } from "../../models/dtos";

export const masterDegreeTypesApi = createApi({
  reducerPath: 'masterDegreeTypesApi',
  baseQuery: baseAuthQuery('MasterDegreeTypes'),
  tagTypes: ['MasterDegreeType'],
  endpoints: (builder) => ({
    getMasterDegreeTypes: builder.query<ApiResponse<MasterDegreeTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['MasterDegreeType'],
    }),
    getMasterDegreeTypeById: builder.query<ApiResponse<MasterDegreeTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['MasterDegreeType'],
    }),
    updateMasterDegreeType: builder.mutation<ApiResponse<MasterDegreeTypeResponse>, Partial<MasterDegreeTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['MasterDegreeType'],
    }),
    deleteMasterDegreeType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['MasterDegreeType'],
    }),
  }),
});
